<template>
  <tbody class="item-tab relative total-amount">
    <loading v-if="sellerSelect === orders._id.seller[0]._id.toString()" :active.sync="loadingShowPay" :is-full-page="fullPage"></loading>
    <tr class="border-b border-gray-200 hover:bg-gray-100">
      <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
        <div class="text-xs leading-5 capitalize rounded-full">
          <div class="font-bold text-gray-700">
            <span><i class="material-icons tiny">contacts</i><span>{{ orders._id.seller[0].fullName }}</span></span>
          </div>
          <div class="font-light text-gray-700">
            <span><i class="material-icons tiny">email</i><span>{{ orders._id.seller[0].email }}</span></span>
          </div>
        </div>
      </td>
      <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300 text-center">
        <div class="text-xs leading-5 capitalize rounded-full text-gray-900">
          {{ orders.count }}
        </div>
      </td>
      <td class="px-3 text-center py-1 whitespace-no-wrap border-b border-gray-300">
        <div class="text-xs leading-5 capitalize rounded-full text-gray-900">
          {{ orders.amount }}
          <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
        </div>
      </td>
      <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
        <div class="flex justify-center">
          <div class="text-black opacity-75 cursor-pointer  hover:text-orange-500">
            <div @click="getOrdersBySeller(orders._id.seller[0])">
              <i class="material-icons mx-2"> remove_red_eye</i>
            </div>
          </div>
          <button @click="OpenClosePopPayMethode('open', 'allOrders', orders._id.seller[0])" class="bg-gray-800 text-xs text-white px-5 py-1 font-semibold rounded uppercase hover:bg-gray-700  relative loading-amount" :class="loadingShowPay ? 'disabled-loading' : ''">
            Pay All
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</template>
<script>
export default {
  props: {
    item: Object,
    cuurency: String,
    loadingShowPay: Boolean,
    idWharhouse: { type: Object },
    citiesPrices: { type: Array },
    sellerSelect: String,
    warehouse: String,
  },
  data: function () {
    return {
      orders: this.item,
      amountBySeller: 0,
      fullPage: false,
      loading: false,
    };
  },
  methods: {
    OpenClosePopPayMethode: async function (action, type, order) {
      this.$emit('OpenClosePopPayMethode', action, type, order);
    },
    getOrdersBySeller: async function (seller) {
      this.$emit('getOrdersBySeller', seller);
    },
    getElementInArray(data, value) {
      var result = data.filter(function (o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null;
    },
    getPriceBycity(city, array) {
      let price = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i].name.toLowerCase() === city.toLowerCase()) {
          price = array[i].price;
          break;
        }
      }
      return price;
    }
  }
};
</script>
